import React from "react";

class PardotTrackingScript extends React.Component {
    render() {
        return (
            <script type="text/javascript" dangerouslySetInnerHTML={{
                __html:
`
piAId = '362321';
piCId = '1505';
(function() {
function async_load()
{ var s = document.createElement('script'); s.type = 'text/javascript'; s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js'; var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c); }
if(window.attachEvent)
{ window.attachEvent('onload', async_load); }
else
{ window.addEventListener('load', async_load, false); }
})();
`
            }} />
        );
    }
}

export default PardotTrackingScript;    
